import { html } from "lit";
var icon_check_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M25.553 8.188c.04.034.077.07.11.111l.11.132c.304.37.304.903 0 1.273l-5.18 6.276-1.267 1.536-4.06 4.922.015-.01-.775.97a1.003 1.003 0 01-.055.078l-.12.159a.877.877 0 01-1.343.062L10.1 20.545l-.8-.872-3.038-3.316a1 1 0 01-.066-1.272l.108-.144a.83.83 0 011.279-.066l2.917 3.183.799.872 2.312 2.44 4.448-5.39 1.267-1.536 5.07-6.145a.82.82 0 011.157-.11z" />
  </svg>
`;
export {
  icon_check_default as default
};
//# sourceMappingURL=icon-check.js.map
